module.exports = `${require.publicPath}401.d858b752.png`;